import { render, staticRenderFns } from "./ReferenceInformationCardIndex.vue?vue&type=template&id=85523e90&"
import script from "./ReferenceInformationCardIndex.vue?vue&type=script&lang=js&"
export * from "./ReferenceInformationCardIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports